import { oc } from '@orpc/contract';
import { listWeeksInputSchema, listWeeksOutputSchema } from '../schemas/weeks.schemas.js';
export const listWeeksContract = oc
    .route({
    method: 'GET',
    path: '/weeks',
    tags: ['Weeks'],
    summary: 'List the reporting weeks (optionally one year) and the current week in Asia/Amman',
})
    .input(listWeeksInputSchema)
    .output(listWeeksOutputSchema);
//# sourceMappingURL=list-weeks.contract.js.map